import { TaxableAnnualIncome } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const taxableAnnualIncomeToPhraseKeyDictionary: EnumDictionary<TaxableAnnualIncome, string> = {
    [TaxableAnnualIncome.UpTo30k]: 'HEAT_PUMP_INTERMEDIARY.HOUSEHOLD.INCOME.UP_TO_30K',
    [TaxableAnnualIncome.UpTo40k]: 'HEAT_PUMP_INTERMEDIARY.HOUSEHOLD.INCOME.UP_TO_40K',
    [TaxableAnnualIncome.UpTo50k]: 'HEAT_PUMP_INTERMEDIARY.HOUSEHOLD.INCOME.UP_TO_50K',
    [TaxableAnnualIncome.Over50k]: 'HEAT_PUMP_INTERMEDIARY.HOUSEHOLD.INCOME.OVER_50K'
};
